import { del, get, post, put, upload } from '@api/request';

export async function fetchAllMarketArea(
  { appraisalService },
  authenticationToken,
  {
    marketArea,
    description,
    year,
    page,
    pageSize,
    tag,
    sortDirection,
    sortField,
  },
) {
  let url = `${appraisalService}/appraisal/marketarea?mktCode=${marketArea}&description=${description}&year=${year}&page=${page}&pageSize=${pageSize}`;
  if (tag) {
    url += `&tag=${tag}`;
  }
  if (sortDirection && sortField) {
    url += `&sortDirection=${sortDirection}&sortField=${sortField}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function saveMarketAreaTags(
  { appraisalService },
  authenticationToken,
  { marketArea, payload },
) {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/tags`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function insertMarketArea(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/marketarea`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMarketArea(
  { appraisalService },
  authenticationToken,
  { marketArea },
) {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateMarketArea(
  { appraisalService },
  authenticationToken,
  { marketArea, payload },
) {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchMarketAreaDetails(
  { appraisalService },
  authenticationToken,
  { marketArea },
) {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/details`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteMarketAreaDetail(
  { appraisalService },
  authenticationToken,
  { marketArea, year, identifier },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/${year}?identifier=${identifier}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export const insertMarketAreaFile = async (
  { appraisalService },
  authenticationToken,
  { marketArea, payload },
) => {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteMarketAreaFile = async (
  { appraisalService },
  authenticationToken,
  { marketArea, s3ID, payload },
) => {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadMarketAreaFile = async (
  { appraisalService },
  authenticationToken,
  { marketArea, s3ID },
) => {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const updateMarketAreaFile = async (
  { appraisalService },
  authenticationToken,
  { marketArea, payload },
) => {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export async function insertMarketAreaDetail(
  { appraisalService },
  authenticationToken,
  { marketArea, payload },
) {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/details`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMarketAreaDetail(
  { appraisalService },
  authenticationToken,
  { marketArea, year, identifier },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/${year}?identifier=${identifier ? identifier : ''}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateMarketAreaDetail(
  { appraisalService },
  authenticationToken,
  { marketArea, year, payload },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/${year}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const insertMarketAreaDetailFile = async (
  { appraisalService },
  authenticationToken,
  { marketArea, year, payload },
) => {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/${year}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteMarketAreaDetailFile = async (
  { appraisalService },
  authenticationToken,
  { marketArea, year, s3ID, payload },
) => {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/${year}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadMarketAreaDetailFile = async (
  { appraisalService },
  authenticationToken,
  { marketArea, year, s3ID },
) => {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/${year}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const updateMarketAreaDetailFile = async (
  { appraisalService },
  authenticationToken,
  { marketArea, year, payload },
) => {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/${year}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchMarketAreaUseCodes = async (
  { appraisalService },
  authenticationToken,
  { year, marketArea, identifier },
) => {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/${year}/${identifier}/usecodes`;
  let { body } = await get(authenticationToken, url);
  return body;
};

export const insertMarketAreaUseCodes = async (
  { appraisalService },
  authenticationToken,
  { year, marketArea, identifier, payload },
) => {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/${year}/${identifier}/usecodes`;
  let { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteMarketAreaUseCode = async (
  { appraisalService },
  authenticationToken,
  { year, marketArea, identifier, useCd },
) => {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(
    encodeURIComponent(marketArea),
  )}/${year}/${identifier}/usecode/${useCd}`;
  let { body } = await del(authenticationToken, url);
  return body;
};
